var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "试用任务",
            visible: _vm.visible,
            "lock-scroll": true,
            width: "818px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formTool",
              attrs: { model: _vm.formTool, "label-width": "140px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "probationDays",
                            label: "试用期",
                            rules: {
                              required: true,
                              message: "请填写试用期",
                              trigger: "blur",
                            },
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              placeholder: "请输入",
                              clearable: "",
                              size: "small",
                            },
                            model: {
                              value: _vm.formTool.probationDays,
                              callback: function ($$v) {
                                _vm.$set(_vm.formTool, "probationDays", $$v)
                              },
                              expression: "formTool.probationDays",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "probationAmount",
                            label: "试用任务要求",
                            rules: {
                              required: true,
                              message: "请填写试用任务要求",
                              trigger: "blur",
                            },
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              placeholder: "请输入",
                              clearable: "",
                              size: "small",
                            },
                            model: {
                              value: _vm.formTool.probationAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.formTool, "probationAmount", $$v)
                              },
                              expression: "formTool.probationAmount",
                            },
                          }),
                          _vm._v(" " + _vm._s(_vm.goodsUnit) + " "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "cooperateDays",
                            label: "合作期",
                            rules: {
                              required: true,
                              message: "请填写合作期",
                              trigger: "blur",
                            },
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              placeholder: "请输入",
                              clearable: "",
                              size: "small",
                            },
                            model: {
                              value: _vm.formTool.cooperateDays,
                              callback: function ($$v) {
                                _vm.$set(_vm.formTool, "cooperateDays", $$v)
                              },
                              expression: "formTool.cooperateDays",
                            },
                          }),
                          _vm._v(" 天 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "btnBox" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.submit },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }